export enum Roles {
  Spv = 'agency.spvcockpit.spv',
  Bm = 'agency.spvcockpit.bm',
  Abpm = 'agency.spvcockpit.abpm',
  Am = 'agency.spvcockpit.am',
  None = 'none',
}
